import React from 'react'

import styles from './ConfirmationCard.module.css'

import Heading from 'Design/components/Heading'
import Small from 'Design/components/Small'

const ConfirmationCard = (props) => {
  const { emoji, title, body, footer } = props

  return (
    <div className={styles.Container}>
      {(emoji || title) && (
        <div className={styles.Head}>
          {emoji && <Heading>{emoji}</Heading>}
          {title && (
            <Heading level={2} className={styles.Heading}>
              {title}
            </Heading>
          )}
        </div>
      )}
      {body && (
        <div className={styles.Body}>
          <Small>{body}</Small>
        </div>
      )}
      {footer && (
        <div className={styles.Footer}>
          <Small>{footer}</Small>
        </div>
      )}
    </div>
  )
}

export default ConfirmationCard
